import React from 'react';
import { M } from '@dashboard-experience/mastodon';
import {
  DRIVING_EXPERIENCE,
  EMPLOYMENT_MULTIDOC,
  DRIVER_ABSTRACT,
  MVR_DOCUMENTATION_REQUESTED,
} from './constants';
import Verification, { connectToVerifications } from './VerificationBase';
import VerificationHeaderPanel from './VerificationHeaderPanel';
import MatrixVerificationForm from './MatrixVerificationForm';
import MissingInformationHeader from './MissingInformationHeader';
import MatrixVerificationAdditionalInfo from './MatrixVerificationAdditionalInfo';
import DrivingExperience from './DrivingExperience';
import EmploymentMultidocPanel from './Multidoc/EmploymentMultidocPanel';
import MvrDocumentCollection from './MVR/MvrDocumentCollection';

class MatrixVerification extends Verification {
  renderCustomPanel() {
    const { doc, isFinalStep, verification } = this.getRenderAttributes();
    if (!isFinalStep) return null;

    const exceptionType = verification.metadata?.configuration?.exceptionType;
    const matrixFields = verification?.fieldConfigurations?.map(fc => fc.name);
    const isMvrConsent = matrixFields?.includes('mvr_consent');

    switch (exceptionType) {
      case DRIVING_EXPERIENCE:
        return <DrivingExperience verification={verification} />;
      case EMPLOYMENT_MULTIDOC:
        return <EmploymentMultidocPanel {...doc} verification={verification} />;
      case DRIVER_ABSTRACT:
      case MVR_DOCUMENTATION_REQUESTED:
        return <MvrDocumentCollection verification={verification} />;
      default:
        return (
          <div className='matrix-verification-wrapper'>
            <VerificationHeaderPanel
              {...verification}
              hideLogo={isMvrConsent}
            />
            <MissingInformationHeader matrixFields={matrixFields} />
            <M.Grid>
              <MatrixVerificationForm
                fields={verification.fieldConfigurations}
                company={verification.company}
                exceptionType={exceptionType}
              />
              {verification.fieldConfigurations[0]?.additionalInfoKey && (
                <MatrixVerificationAdditionalInfo
                  additionalInfoKey={
                    verification.fieldConfigurations[0].additionalInfoKey
                  }
                />
              )}
            </M.Grid>
          </div>
        );
    }
  }
}

export default connectToVerifications(MatrixVerification);
